<template>
  <BaseDialog
    :is-open="isOpen"
    title="Add Content from URL"
    :confirm-text="scraping ? 'Scraping...' : 'Add Content'"
    :is-loading="scraping"
    width="sm:max-w-2xl"
    @close="$emit('close')"
    @confirm="scrapeContent"
  >
    <div>
      <label class="block text-sm font-medium text-gray-700">URL</label>
      <input
        v-model="url"
        type="url"
        class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
        placeholder="https://example.com/article"
      />
    </div>
    <div>
      <label class="block text-sm font-medium text-gray-700">Source Name (Optional)</label>
      <input
        v-model="sourceName"
        type="text"
        class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
        placeholder="Manual Entry"
      />
    </div>
  </BaseDialog>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import BaseDialog from '@/components/common/BaseDialog.vue'

const props = defineProps<{
  isOpen: boolean
}>()

const emit = defineEmits<{
  (e: 'close'): void
  (e: 'scrape', data: { url: string, sourceName: string }): void
}>()

const url = ref('')
const sourceName = ref('')
const scraping = ref(false)

async function scrapeContent() {
  if (!url.value) {
    alert('Please enter a URL')
    return
  }

  scraping.value = true
  try {
    emit('scrape', {
      url: url.value,
      sourceName: sourceName.value || 'Manual Entry'
    })
    // Reset form
    url.value = ''
    sourceName.value = ''
  } finally {
    scraping.value = false
  }
}
</script> 